import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { urls } from "../../../urls";
import { useApiError } from "../../../common/errors/useApiError";
import { EntityUnavailable } from "../../../common/errors/EntityUnavailable";
import { useAppDispatch, useAppSelector } from "../../../common/redux/hooks";
import { loadContractThunk } from "../../../common/redux/thunks/contract/load-contract-thunk";
import { EditContractForm } from "./EditContractForm";

export const EditContract = () => {
  const { contractId } = useParams();
  const dispatch = useAppDispatch();
  const contractState = useAppSelector((state) => state.contract.state);
  const loadFailure = useAppSelector((state) => state.contract.loadFailure);
  const { t } = useTranslation();
  const { showNoAccess } = useApiError();

  useEffect(() => {
    if (!contractId) return;
    dispatch(loadContractThunk({ contractId }));
  }, [contractId, dispatch]);

  if (!contractId) {
    return <div>{t("404 not found")}</div>;
  }

  if (loadFailure?.contractId === contractId) {
    return (
      <EntityUnavailable
        error={loadFailure.error}
        notFoundMessage={t("This contract doesn't exist, or your organization doesn't have access to it.")}
        forbiddenMessage={t("You don't have access to this contract. Ask an administrator in your organization for access.")}
        loadFailedMessage={t("This contract could not be loaded right now.")}
        onRetry={() => dispatch(loadContractThunk({ contractId }))}
        back={{ to: urls.app.contracts.viewAll, label: t("Back to contracts") }}
      />
    );
  }

  if (contractState?.id !== contractId) {
    return <div>{t("Loading")}...</div>;
  }

  if (!contractState.contract.canEditEverything) {
    return showNoAccess({
      message: t("You can view this contract, but you don't have permission to edit it."),
      destination: { href: urls.app.contracts.view.go(contractId), label: t("Open the contract") },
    });
  }

  return <EditContractForm />;
};

